import { render, staticRenderFns } from "./SearchResultContent.vue?vue&type=template&id=16304648"
import script from "./SearchResultContent.vue?vue&type=script&lang=js"
export * from "./SearchResultContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports